import * as React from 'react';

import AuthForm from './AuthForm';
import * as logo from '../../assets/image/EOS_Logo_Colored.svg';
import './style.scss';

function Auth (){
  return(
    <section className='auth d-flex flex-column align-center justify-center'>
      <img
        className='auth-logo'
        src={logo} />
      <div className='d-flex'>
        <AuthForm />
      </div>
    </section>
  );
}

export default React.memo(Auth);
